import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Button,
  Switch,
} from '@mui/material';

const SettingsTab = ({credential, onToggleActive, onLivePeriod}) => {
  return (
    <Card>
      <CardContent>
        <Typography variant='h6' gutterBottom>
          Settings
        </Typography>
        <List>
          <ListItem>
            <ListItemText
              primary='Live Period Management'
              secondary='Configure how long this API credential should remain active'
            />
            <ListItemSecondaryAction>
              <Button variant='outlined' onClick={onLivePeriod}>
                Configure
              </Button>
            </ListItemSecondaryAction>
          </ListItem>
          <ListItem>
            <ListItemText
              primary='Active Status'
              secondary='Enable or disable data collection for this API credential'
            />
            <ListItemSecondaryAction>
              <Switch
                checked={!!credential.is_active}
                onChange={onToggleActive}
              />
            </ListItemSecondaryAction>
          </ListItem>
        </List>
      </CardContent>
    </Card>
  );
};

SettingsTab.propTypes = {
  credential: PropTypes.shape({
    is_active: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  }).isRequired,
  onToggleActive: PropTypes.func.isRequired,
  onLivePeriod: PropTypes.func.isRequired,
};

export default SettingsTab;
